import { Component, OnInit, Input, ViewChild, ElementRef } from "@angular/core";
import { BaseComponent } from "../../base.component";
import { MeshutafUserFormComponent } from "./meshutaf-user-form.component";

import { Observable } from "rxjs/Observable";
import { of } from "rxjs/observable/of";
import { SessionManagerService } from "../../_services/SessionManager/session-manager.service";
import { DataService } from "../../_services/data.service";
import { AlertService } from "../../_services/alert.service";

@Component({
  moduleId: module.id,
  selector: "meshutaf-users",
  templateUrl: "meshutaf-users.component.html",
})
export class MeshutafUsersComponent extends BaseComponent {
  @ViewChild("userComponent") public userComponent: MeshutafUserFormComponent;
  public users: any = [];
  public loading = false;
  public userModel: any;
  public selectedUser: any;
  public searching: boolean;
  public searchFailed: boolean;
  searchingUser: boolean;
  messages: any;
  hideSearchingWhenUnsubscribed = new Observable(
    () => () => (this.searching = false)
  );

  constructor(
    public dataService: DataService,
    private alertService: AlertService,
    public sessionManager: SessionManagerService
  ) {
    super(dataService, sessionManager);
  }

  public userFormatter = (user: { firstName: string; lastName: string }) =>
    user.firstName + " " + user.lastName;

  run() {}

  clearSearch() {
    this.userModel = "";
    this.userComponent.setUser();
  }

  select(event) {
    let user = event.item;

    this.selectedUser = user;
    this.userComponent.setUser(user);
    //   		if (this.mihlolEventSelected){
    //   			//check if ther are events and no such event yet
    //   			e.added = true;
    //   			e.isAllowed = true;
    //   			if (this.mihlolEventSelected && this.mihlolEventSelected.events && this.mihlolEventSelected.events.length > 0){
    //   				let isThere = false;
    //   				this.mihlolEventSelected.events.forEach((ev)=>{
    //   					if (ev.id == e.id)
    //   						isThere = true;
    //   				});
    //   				if (!isThere)
    //   				this.mihlolEventSelected.events.push(e);
    //   			}
    //   			else{
    //   				this.mihlolEventSelected['events'] = [e];
    //   			}
    //   			$('.fa.fa-times-circle').click();
    //   			this.updated = true;
    //
    // //   			this.model = '';
    //
    //   		}
  }

  search = (text$: Observable<string>) =>
    text$
      .debounceTime(300)
      .distinctUntilChanged()
      .filter((query: string) => query && query.length > 2)
      .do(() => (this.searching = true))
      .switchMap((term) =>
        this.dataService
          .getAdminUsers(term)
          .do(() => (this.searchFailed = false))
          .catch(() => {
            this.searchFailed = true;
            return of([]);
          })
      )
      .do(() => (this.searching = false))
      .merge(this.hideSearchingWhenUnsubscribed);
}



// WEBPACK FOOTER //
// ./src/app/admin/meshutaf-users/meshutaf-users.component.ts